import { Component, ViewChild, Input, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { helper } from 'src/environments/helper';
import { DataTableDirective } from 'angular-datatables';
import { finalize, map, Observable, Subject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DialogService } from '../../../../../../utils/services/dialog.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Generic } from '../../../../../../interfaces/generic.interface';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { Client } from '../../client.interface';
import { ModulesService } from '../../../administration/admin-settings/modules/modules.service';
import { AddClientModuleComponent } from './add-client-module/add-client-module.component';
import { ClientModulesService } from './client-modules.service';
import { EditClientModuleComponent } from './edit-client-module/edit-client-module.component';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'app-client-modules',
    templateUrl: './client-modules.component.html',
    styleUrls: ['./client-modules.component.scss']
})
export class ClientModulesComponent implements OnInit {
    @Input() client!: Client;
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    showCard = false;
    activeValue: string = '-1';

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    defaultParameter: { name: string; id_directie: string } = {
        name: '--Alegeți--',
        id_directie: '-1',
    };

    toggleCard() {
        this.showCard = !this.showCard;
    }
    constructor(
        private dialogService: DialogService,
        public clientModulesService: ClientModulesService,
        public modulesService: ModulesService,
        private http: HttpClient,
        private dialog: MatDialog,
        public permissionsService: PermissionsService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    resetForm() {
        this.activeValue = '-1';

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }


    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            pageLength: 25,
            responsive: true,

            ajax: (dataTablesParameters: any, callback: any) => {
                dataTablesParameters.client_id = this.client.id_client;
                dataTablesParameters.active = this.activeValue;

                this.isLoading = true;

                this.clientModulesService
                    .getClientModulesDT(dataTablesParameters)
                    .pipe(
                        finalize(() => {
                            this.isLoading = false;
                        })
                    )
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            order: [[4, 'asc']],
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                    visible: false,
                },
                {
                    title: 'ID Modul',
                    data: 'module_id',
                },
                {
                    title: 'Nume Modul',
                    data: 'module_name',
                },
                {
                    title: 'Slug Modul',
                    data: 'module_slug',
                },
                {
                    title: 'Order',
                    data: 'order',
                    sortable: false,
                    render: (data: any, type: any, row: any, met: any) => {
                        return `<div class="order-section-dt">
                            <button type="button" class="action-btn down-order btn btn-sm btn-primary" (click)="updateOrder(${row.id}, 1)">
                                <img class="btn-img" src="/assets/icons/down-white.svg" alt="down-order"/>
                            </button>
                            <span class="order">${row.order}</span>
                            <button type="button" class="action-btn up-order btn btn-sm btn-primary" (click)="updateOrder(${row.id}, -1)">
                                <img class="btn-img" src="/assets/icons/up-white.svg" alt="up-order"/>
                            </button>
                        </div>`;
                    },
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    className: 'all',
                    orderable: false,
                    render: (data: any, type: any, row: any, met: any) => {
                        return (
                            `    
                  <div class="d-flex align-center justify-content-left">
                            <button class="action-btn edit">
                                <img class="btn-img" src="/assets/icons/edit.svg" alt="edit"/>
                            </button>          
                            <button type="button" class="action-btn update_status_active ms-1 ` +
                            (row.active == true ? 'action-success' : 'action-danger') +
                            `">
                                <img class="btn-img" src="` +
                            (row.active == true
                                ? '/assets/icons/check-white.svg'
                                : '/assets/icons/close-white.svg') +
                            `"        alt="update_status_active"/>
                            </button>              
                            <button type="button" class="action-btn delete ms-1">
                                <img class="btn-img" src="/assets/icons/delete.svg" alt="delete"/>
                            </button>
                            </div>
                        `
                        );
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd ?.querySelector('.edit') as HTMLElement;
                const updateStatusActiveIcon = lastTd ?.querySelector(
                    '.update_status_active'
                ) as HTMLElement;
                const deleteIcon = lastTd ?.querySelector('.delete') as HTMLElement;

                const orderTD = (row as HTMLElement).querySelector(
                    'td:nth-child(4)'
                ) as HTMLElement;
                const upOrder = orderTD ?.querySelector('.up-order') as HTMLElement;
                const downOrder = orderTD ?.querySelector(
                    '.down-order'
                ) as HTMLElement;

                if (upOrder) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.clients.update-module-users'
                        )
                    ) {
                        upOrder.style.display = 'none';
                    }
                    upOrder.addEventListener('click', () => {
                        const { id } = data;
                        this.updateOrder(id, -1);
                    });
                }

                if (downOrder) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.clients.update-module-users'
                        )
                    ) {
                        downOrder.style.display = 'none';
                    }
                    downOrder.addEventListener('click', () => {
                        const { id } = data;
                        this.updateOrder(id, 1);
                    });
                }

                if (editIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.clients.update-module-users'
                        )
                    ) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (updateStatusActiveIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.clients.update-module-users'
                        )
                    ) {
                        updateStatusActiveIcon.style.display = 'none';
                    }
                    updateStatusActiveIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.changeStatusActive(id);
                    });
                }

                if (deleteIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.clients.update-module-users'
                        )
                    ) {
                        deleteIcon.style.display = 'none';
                    }
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.deleteClientModule(id);
                    });
                }

                return row;
            },
        };
    }

    updateOrder(id: number, index: number) {
        console.log(id, index);

        this.isLoading = true;
        this.clientModulesService.updateOrder(id, { order: index })
            .pipe(finalize(() => { this.isLoading = false; }))
            .subscribe(
                () => {
                    this.rerenderDT();
                },
                (err: any) => {
                    this.rerenderDT();
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }

                    Swal.fire({
                        title: helper.dialogConfig.headers.errorAtentie,
                        text: msg,
                        icon: 'error',
                        showCancelButton: true,
                        cancelButtonText: helper.dialogConfig.buttonLabels.close,
                        reverseButtons: true,
                        allowOutsideClick: false,
                    });
                }
            );
    }

    changeStatusActive(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să actualizați statusul modului selectat asignat clientului!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusActiveAction(id);
            }
        });
    }

    changeStatusActiveAction(id: number) {
        this.isLoading = true;
        const changeStatusActiveUrl = environment.interop.basePath + environment.interop.clients.modules.changeStatusContactActive;

        this.clientModulesService.changeStatusActive(id)
            .pipe(finalize(() => { this.isLoading = false; }))
            .subscribe(
                () => {
                    this.rerenderDT();
                    Swal.fire({
                        title: helper.dialogConfig.headers.success,
                        text: 'Modulul clientului actualizat cu succes.',
                        icon: 'success',
                        confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        allowOutsideClick: false,
                    });
                },
                (err: any) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.rerenderDT();
                    Swal.fire({
                        title: helper.dialogConfig.headers.errorAtentie,
                        text: msg,
                        icon: 'error',
                        confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                        showCancelButton: true,
                        cancelButtonText: helper.dialogConfig.buttonLabels.close,
                        reverseButtons: true,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.changeStatusActiveAction(id);
                        }
                    });
                }
            );
    }

    deleteClientModule(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.deleteAction(id);
            }
        });
    }

    deleteAction(id: number) {
        this.isLoading = true;
        const deleteUrl = environment.interop.basePath + environment.interop.clients.modules.deleteClientModule;

        this.clientModulesService.deleteClientModule(id)
            .pipe(finalize(() => { this.isLoading = false; }))
            .subscribe(
                () => {
                    this.rerenderDT();
                    Swal.fire({
                        title: helper.dialogConfig.headers.success,
                        text: 'Înregistrarea ștearsă cu succes!',
                        icon: 'success',
                        confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        allowOutsideClick: false,
                    });
                },
                (err: any) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }

                    Swal.fire({
                        title: helper.dialogConfig.headers.errorAtentie,
                        text: msg,
                        icon: 'success',
                        confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                        showCancelButton: true,
                        cancelButtonText: helper.dialogConfig.buttonLabels.close,
                        reverseButtons: true,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.deleteAction(id);
                        }
                    });
                }
            );
    }


    rerenderDT(paginate: boolean = false): void {

        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
        this.showCard = false;
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddClientModuleComponent, {
            ...this.dialogService.getDialogConfig(),
            data: this.client,
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Modul adaugat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditClientModuleComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                id: data.id,
                id_client: this.client.id_client
            },
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Modul actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }
}
